export const onShowConfirmSignLock = async ({
  clinicalNote,
  showConfirmSignLock,
  params = {},
  startLoading = () => {},
  stopLoading = () => {},
  saveButtonText,
  setClinicalNote,
  setAdvancedHP,
  setAdvancedSOAP,
  setCustomFormTypes,
  setIsExport,
  saveNoteRef = null,
  navigate,
  setShowPreviewNoteLoading = () => {},
  showPreviewNote = () => {}
}) => {
  if (!clinicalNote) {
    stopLoading();
    return;
  }

  if (clinicalNote?.locked) {
    stopLoading(false);
    showConfirmSignLock(true);
    return;
  }

  startLoading();
  await showPreviewNote({
    patientId: clinicalNote?.user_id || params?.id,
    appointmentId: clinicalNote?.appointment_id || params?.appointmentId,
    saveButtonText,
    exportNote: true,
    setClinicalNote,
    setAdvancedHP,
    setAdvancedSOAP,
    setCustomFormTypes,
    setPreviewNoteModal: showConfirmSignLock,
    setIsExport,
    setLoading: setShowPreviewNoteLoading,
    onSaveNote: saveNoteRef?.current?.onSaveNote,
    navigate
  });
  stopLoading(false);
};
